// node_modules
import { FC, useEffect, useState } from "react";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
// Components
import { FindestTextBox, PositionedPopup, Label } from "Components";
// Custom hooks
import { useDebounce } from "Hooks";
// Types
import { TSearchTechnologyResultDTO } from "Types";
// Controllers
import { TechnologyControllerSingleton } from "Controllers";
// styles
import styles from "./technologySearchBar.module.scss";
// Helpers
import { AxiosHelperSingleton } from "Helpers";

export const TechnologySearchBar: FC = () => {
    // State
    const [technologyName, setTechnologyName] = useState<string | undefined>(undefined);
    const [technologyResults, setTechnologyResults] = useState<TSearchTechnologyResultDTO[]>([]);

    // Custom hooks
    const debouncedTechnologyName = useDebounce(technologyName, 250);

    // Logic
    const searchTechnology = async (name: string): Promise<void> => {
        setTechnologyResults(await TechnologyControllerSingleton.searchTechnologyAsync(name));
    };

    const onTechnologyResultClickHandler = (clickedTechnologyResultId: number, clickedTechnologyResultCaseId: number): void => {
        window.location.replace(`${AxiosHelperSingleton.getServerBaseURL()}cases/${clickedTechnologyResultCaseId}/delivery/results/phase1#gototechnology-${clickedTechnologyResultId}`);
    };

    useEffect(() => {
        if (debouncedTechnologyName) {
            searchTechnology(debouncedTechnologyName);
        } else {
            setTechnologyResults([]);
        }
    }, [debouncedTechnologyName]);
    
    return (
        <div className={styles.technologySearchBarContainer}>
            <FindestTextBox 
                leftIcon={faSearch} 
                onChange={setTechnologyName} 
                placeholder="Search technologies..." />
            {technologyResults.length > 0 ?
                    <div className={styles.technologySearchResultsContainer}>
                        <PositionedPopup>
                            <div>
                                {technologyResults.map((technologyResult: TSearchTechnologyResultDTO) => {
                                    return (
                                        <div key={technologyResult.id}
                                            className={styles.technologySearchResults}
                                            onClick={() => onTechnologyResultClickHandler(technologyResult.id, technologyResult.caseId)}>
                                            <div className={styles.technologySearchResultNameContainer}>
                                                {technologyResult.name}
                                            </div>
                                            <Label 
                                                text="Technology" 
                                                color="#212121"
                                                backgroundColor="#CCCCCC" />
                                        </div>
                                    );
                                })}
                            </div>
                        </PositionedPopup>
                    </div>
                :
                    null
            }
        </div>
    );
};
